import { BaseService } from "./baseService";
import httpRequest from "./index";
import type { CustomerReceivingAddress, Page } from "@zhihaoscm/entity";

/** 表单字段沿用实体合同，页面可在此基础上收紧必填校验。 */
export type CustomerReceivingAddressForm = Partial<CustomerReceivingAddress>;

export class AddressService extends BaseService<any, any, any, any> {
    // 查询客户地址列表
    public async getAddressList(params: any): Promise<Page<CustomerReceivingAddress>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    // 查看客户地址详情
    public async getAddressInfoById(id: number): Promise<Page<CustomerReceivingAddress>> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    // 新增客户地址
    public async addCustomerAddress(
        customerReceivingAddressForm: CustomerReceivingAddressForm
    ): Promise<CustomerReceivingAddress> {
        const { data } = await this.service.post(`${this.path}`, customerReceivingAddressForm);
        return data;
    }

    // 修改客户地址
    public async editCustomerAddress(
        id: number,
        customerReceivingAddressForm: CustomerReceivingAddressForm
    ): Promise<Page<CustomerReceivingAddress>> {
        const { data } = await this.service.put(`${this.path}/${id}`, customerReceivingAddressForm);
        return data;
    }

    // 设置默认值
    public async setDefault(
        id: number,
        customerReceivingAddressForm: CustomerReceivingAddressForm
    ): Promise<Page<CustomerReceivingAddress>> {
        const { data } = await this.service.put(`${this.path}/${id}`, customerReceivingAddressForm);
        return data;
    }

    // 查看客户地址详情
    public async deleteAddressById(id: number): Promise<Page<CustomerReceivingAddress>> {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    // 查询客户地址列表
    public async getCustomerAddress(): Promise<CustomerReceivingAddress[]> {
        const { data } = await this.service.get(`${this.path}/custom`);
        return data;
    }
}

export const addressService = new AddressService("/customer/receiving-address", httpRequest);
